import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

function AtletasNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/7b22204017c50d4f304e554e533f6383.jpeg"
                alt="AAPEQ"
                className="h-12 w-auto"
              />
            </Link>
          </div>

          <div className="hidden sm:flex items-center gap-6">
            <button
              onClick={() => navigate(-1)}
              className={`flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer bg-transparent border-none ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              <i className="ri-arrow-left-line text-base"></i>
              Voltar
            </button>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Atletas+%E2%80%94+menu+superior+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#F05954] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#d94943] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Entrar na AAPEQ
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="sm:hidden p-2 cursor-pointer"
          >
            <i
              className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
                isScrolled ? 'text-[#262364]' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="sm:hidden bg-white border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-3 px-4">
              <button
                onClick={() => { setIsMobileMenuOpen(false); navigate(-1); }}
                className="flex items-center gap-2 text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
              <a
                href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Atletas+%E2%80%94+menu+mobile+%E2%80%94+Quero+entrar+na+AAPEQ"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F05954] text-white px-5 py-3 rounded-full text-sm font-medium text-center hover:bg-[#d94943] transition-all cursor-pointer block"
              >
                Entrar na AAPEQ
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default function AtletasPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <AtletasNavbar />

      {/* Banner */}
      <div className="relative w-full h-[260px] sm:h-[300px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/94a326d68e3118aaab8374c5810c4080.jpg"
          alt="Atletas Profissionais — AAPEQ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center px-5 text-center">
          <div className="inline-block bg-[#F05954] text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            Alta Performance
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight">
            Atletas Profissionais — AAPEQ
          </h1>
          <p className="text-sm sm:text-base text-white/80 mt-3 max-w-xl">
            Alta performance física, mental e energética
          </p>
        </div>
      </div>

      <div className="max-w-screen-xl mx-auto">

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              A AAPEQ desenvolveu um treinamento específico para atletas profissionais e praticantes de esportes de alto desempenho, com foco no aprimoramento da capacidade física, mental, emocional e energética necessária para ambientes competitivos.
            </p>
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              O processo é direcionado para atletas que buscam ampliar foco, disciplina, resistência emocional e capacidade de tomada de decisão sob pressão.
            </p>
            <p className="text-base text-gray-700 leading-relaxed font-semibold">
              Entre os profissionais atendidos estão:
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                'Atletas olímpicos',
                'Lutadores de alto rendimento (Jiu-Jitsu, MMA, Muay Thai, Judo, Karate, Taekwondo)',
                'Corredores e maratonistas',
                'Alpinistas e praticantes de esportes de resistência extrema',
                'Jogadores de futebol, vôlei, basquete, handebol',
                'Ginastas, acrobatas e atletas de solo',
                'Triatletas, ciclistas e nadadores',
                'Profissionais do esporte em qualquer categoria de competição real'
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-star-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">O Que é Trabalhado</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                'Foco mental para competição',
                'Controle emocional em ambientes de pressão',
                'Disciplina interna e clareza de objetivos',
                'Leitura de ambiente e percepção estratégica',
                'Fortalecimento físico e estrutural do corpo',
                'Aumento da resistência emocional e mental',
                'Regeneração celular e recuperação do desgaste físico',
                'Reorganização do campo energético pessoal',
                'Desbloqueio de traumas emocionais ligados ao esporte'
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-tools-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Técnicas Aplicadas</h2>
            </div>
            <div className="space-y-3">
              {[
                'Protocolos de foco e percepção ampliada',
                'Organização mental para tomada de decisões rápidas',
                'Controle respiratório e estabilidade emocional',
                'Fortalecimento da estrutura física e articular',
                'Preparação mental para competição',
                'Equilíbrio entre força, sensibilidade e direção pessoal'
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg border-l-4 border-[#F05954]">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-fire-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Resultados do Treinamento</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">O atleta desenvolve:</p>
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {[
                'Maior clareza estratégica',
                'Aumento da resistência mental',
                'Foco prolongado em treinos e competições',
                'Estabilidade emocional durante disputas',
                'Maior controle sobre seu estado interno',
                'Fortalecimento físico e mental'
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#262364] text-white p-5 sm:p-6 rounded-xl">
              <p className="text-base font-semibold">
                O objetivo é preparar o atleta para atuar com mais consciência, equilíbrio e potência em ambientes competitivos.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 sm:py-20 px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-black text-[#262364] mb-6">
              Quer elevar sua performance com foco, força interna e estabilidade mental?
            </h2>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Atletas+%E2%80%94+CTA+final+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full sm:w-auto bg-[#F05954] text-white px-6 py-4 rounded-full text-base font-semibold hover:bg-[#262364] transition-all cursor-pointer mx-4 sm:mx-0"
            >
              Entrar na AAPEQ — Atletas Profissionais
            </a>
            <div className="mt-8">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#262364] transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}